<template>
  <div>
    <basic-container>
      <div class="page-container">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <date-range-destructor
                :start.sync="form.createDateBegin"
                :end.sync="form.createDateEnd"
                start-placeholder="绑定开始时间"
                end-placeholder="绑定结束时间"
                type="daterange"
                value-format="yyyy-MM-dd"
                format = "yyyy-MM-dd">
              </date-range-destructor>
            </el-form-item>
            <el-form-item>
              <el-input style="width: 400px;" clearable v-model="form.keyword" placeholder="合伙人账号/设备HID/设备UID/设备MAC地址/绑定操作账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-auth="'ACTIVITY_PARTNER_SEARCH'" :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="bindedLogs"
            ref="eltable"
            :height="autoTableHeight"
            v-loading="listLoading"
            @selection-change="handleSelect"
            border
            style="width: 100%">
            <el-table-column
              type="index"
              fixed
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column
              prop="bindUserAccount"
              align="center"
              header-align="center"
              label="合伙人账号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="bindUserInviteCode"
              align="center"
              header-align="center"
              label="邀请码"
              width="180">
            </el-table-column>
            <el-table-column
              prop="title"
              label="设备名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="hid"
              label="设备HID"
              width="300">
            </el-table-column>
            <el-table-column
              prop="uid"
              label="设备UID"
              width="200">
            </el-table-column>
            <el-table-column
              prop="emac"
              min-width="300"
              label="设备MAC地址">
            </el-table-column>
            <el-table-column
              prop="fromUserAccount"
              align="center"
              header-align="center"
              label="绑定操作账号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="bindTime"
              align="center"
              header-align="center"
              width="180"
              label="绑定时间">
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination
            :page-size.sync="pageConfig.size"
            :total="total"
            :current-page.sync="pageConfig.current"
            @change="handlePageChange"
          />
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { merge } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
  export default {
    name: 'BindedDeviceLogsPage',
    mixins: [ListMixins],
    data() {
      return {
        listLoading: false,
        form: {
          createDateBegin: '',
          createDateEnd: '',
          keyword: ''
        },
      }
    },
    computed: {
      ...mapState('partner', ['bindedLogs', 'total']),
      ...mapGetters('app', ['viewportSize']),
      popupTitle() {
        return this.isEdit ? '编辑' : '新增';
      }
    },
    methods: {
      ...mapActions('partner', ['getBindedDeviceList']),
      getList() {
        const query = merge({}, this.form, this.pageConfig);
        this.listLoading = true;
        this.getBindedDeviceList(query).finally(() => {
          this.listLoading = false;
        });
      }
    },
    created() {
      this.form.keyword = this.$route.query.id;
      this.getList();
    }
  }
</script>
<style lang="scss">
  .table-pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>
